import RequestService from 'services/request.service'

import { alpha, cardType, cmc, color } from 'redux/deck/helpers/sorting'

import { CardType, CategoryType } from 'types/deck'

export type SortMethod = 'alpha' | 'manaValue' | 'color' | 'type'

export function generatePDFFile(
  deck: Array<CardType>,
  categoryMap: Record<string, CategoryType>,

  sortMethod: SortMethod,

  deckName: string,
  date: string,
  firstName: string = '',
  lastName: string = '',
  designer: string = '',
  dci: string = '',
  location: string = '',
  event: string = '',
) {
  let sortMethodFunction = alpha

  if (sortMethod === 'manaValue') sortMethodFunction = cmc
  if (sortMethod === 'color') sortMethodFunction = color
  if (sortMethod === 'type') sortMethodFunction = cardType

  const sideboard = deck.filter(card => categoryMap[card.categories[0]].name === 'Sideboard').sort(sortMethodFunction)
  const restOfDeck = deck.filter(card => categoryMap[card.categories[0]].name !== 'Sideboard').sort(sortMethodFunction)

  let mapToPdf: Record<string, string | number> = {}
  let deckSize = 0
  let sideboardSize = 0

  for (let [index, card] of restOfDeck.entries()) {
    mapToPdf[`card_${index}`] = card.name
    mapToPdf[`card_${index}_qty`] = card.qty

    deckSize += card.qty
  }

  for (let [index, card] of sideboard.entries()) {
    mapToPdf[`sideboard_${index}`] = card.name
    mapToPdf[`sideboard_${index}_qty`] = card.qty

    sideboardSize += card.qty
  }

  for (let index = 0; index < dci.length; index++) {
    const character = dci[index]

    mapToPdf[`dci_${index}`] = character
  }

  return handlePdfExport({
    ...mapToPdf,
    deckSize,
    sideboardSize,
    deckName,
    date,
    firstName,
    lastName,
    designer,
    location,
    event,
    firstOfLastName: lastName ? lastName.charAt(0) : '',
  })
}

export const handlePdfExport = (params: any) => {
  return RequestService.post('/api/decks/exportPdf/', params).then(results => {
    const body = document.body

    if (body) {
      let element = document.createElement('a')
      element.setAttribute('href', results.fileUrl)
      // element.setAttribute('download', filename) // Can't be used because the PDF is from a different domain
      element.style.display = 'none'
      body.appendChild(element)
      element.click()
      body.removeChild(element)
    }
  })
}
